import React from 'react';

interface ResponsiveGridProps {
  children: React.ReactNode;
  minCardWidth?: number;
  gap?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Reusable responsive grid component that automatically adjusts columns based on available space
 */
export const ResponsiveGrid: React.FC<ResponsiveGridProps> = ({
  children,
  minCardWidth = 250,
  gap = 'md',
  className = ''
}) => {
  const gapMap = {
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem'
  };
  
  const gapSize = gapMap[gap];
  
  return (
    <div 
      className={className}
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fit, minmax(${minCardWidth}px, 1fr))`,
        gap: gapSize
      }}
    >
      {children}
    </div>
  );
};

export default ResponsiveGrid;
